/* lys-attribution.js — CRID — la provenance de chaque vente, gravée dans la commande (filet de secours : il ne mesure pas
 * à la place de Google, il garantit qu'aucune VENTE ne perd son origine). Tout est en try/catch : au pire il ne note rien.
 *
 * 19/09/2026 — TROIS CORRECTIONS (ordre du patron : « corrige tout »), avant l'arrivée de Google Ads :
 *  1. RIEN N'EST ÉCRIT NI LU SUR L'APPAREIL AVANT L'ACCORD DU VISITEUR. Avant, le cookie `lys_attr` (30 jours) et le
 *     localStorage partaient dès l'arrivée, avant tout choix sur la bannière. Désormais on écoute l'API de consentement de
 *     Shopify (la même que crid-consentement) : `marketingAllowed()` doit répondre true. En attendant, la provenance de LA
 *     PAGE reste en mémoire (lire l'URL n'écrit rien) et n'est enregistrée que si l'accord arrive sur cette page.
 *     Refus → rien n'est noté, et ce qui avait été enregistré avant est effacé. Hors Europe (aucun accord exigé), Shopify
 *     répond true tout de suite : rien ne change.
 *  2. LE DERNIER CLIC PUBLICITAIRE EST GRAVÉ AUSSI (`lys_clic_dernier`). Avant, seul le clic de la PREMIÈRE visite partait
 *     dans la commande : un clic Pinterest payant (epik) masquait pour toujours le gclid d'une annonce Google venue après.
 *  3. `gad_source` / `gad_campaignid` sont captés (`lys_gad`) : sur iPhone une annonce Google arrive souvent sans gclid.
 *  Après relecture adverse (2 relecteurs) : le dernier clic est REPORTÉ 90 jours à travers les visites sans clic (annonce →
 *  départ → retour en direct pour acheter) ; un accord donné ailleurs que sur la page d'arrivée laisse une trace honnête
 *  « (inconnue) » plutôt que rien ; les identifiants Google Analytics exigent l'accord ANALYTIQUE ; au retrait de l'accord,
 *  nos clés déjà gravées dans le panier sont vidées.
 *  ⚠ LIMITE ASSUMÉE : on ne connaît plus la provenance que des visiteurs qui cliquent « Accepter » (ou hors Europe). Ceux qui
 *  refusent OU qui ignorent la bannière ne laissent rien. Retour arrière : `_gsuivi/13_mettre_en_ligne.mjs --restaurer`.
 */
(function () {
  'use strict';

  var CLE = 'lys_attr';           // première visite — ne change plus pendant 30 jours
  var CLE_D = 'lys_attr_last';    // dernière visite — écrasée à chaque nouvelle source
  var JOURS = 30;

  function lire(k) {
    try {
      var v = localStorage.getItem(k);
      if (v) return JSON.parse(v);
    } catch(e){window.LE&&LE(e)}
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
      if (m) return JSON.parse(decodeURIComponent(m[1]));
    } catch(e){window.LE&&LE(e)}
    return null;
  }

  function ecrire(k, o) {
    var s = JSON.stringify(o);
    try { localStorage.setItem(k, s); } catch(e){window.LE&&LE(e)}
    try {
      // cookie de repli : survit au localStorage bloqué (Safari navigation privée)
      document.cookie = k + '=' + encodeURIComponent(s) + ';path=/;max-age=' + (JOURS * 86400) + ';SameSite=Lax';
    } catch(e){window.LE&&LE(e)}
  }

  function effacer(k) {
    try { localStorage.removeItem(k); } catch(e){window.LE&&LE(e)}
    try { document.cookie = k + '=;path=/;max-age=0;SameSite=Lax'; } catch(e){window.LE&&LE(e)}
  }

  function params() {
    try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; }
  }

  /* Les identifiants de clic sont la preuve la plus fiable d'une provenance payante :
     ils survivent même quand le référent est vide. */
  var CLICS = {
    gclid: 'google/cpc', gbraid: 'google/cpc', wbraid: 'google/cpc',
    fbclid: 'facebook/paid', ttclid: 'tiktok/paid', msclkid: 'bing/cpc',
    epik: 'pinterest/paid', sccid: 'snapchat/paid', li_fat_id: 'linkedin/paid'
  };

  function depuisReferent(r) {
    if (!r) return { source: '(direct)', medium: '(none)' };
    var h;
    try { h = new URL(r).hostname.replace(/^www\./, ''); } catch (e) { return { source: '(direct)', medium: '(none)' }; }
    // notre propre domaine ne doit JAMAIS compter comme source
    if (/(^|\.)cridfc\.com$/i.test(h) || /myshopify\.com$/i.test(h) ||
        /(^|\.)(shopify|shop\.app|shopifycdn)\.com$/i.test(h) || /(^|\.)admin\.shopify\.com$/i.test(h)) {
      return null; // auto-référence → on garde ce qui était déjà enregistré
    }
    if (/(^|\.)(google|bing|yahoo|duckduckgo|ecosia|qwant|yandex|baidu)\./i.test(h))
      return { source: h.split('.')[0], medium: 'organic' };
    if (/(^|\.)(facebook|instagram|tiktok|pinterest|twitter|x|snapchat|linkedin|reddit|youtube)\./i.test(h))
      return { source: h.split('.')[0], medium: 'social' };
    // passerelles de paiement : jamais une source, c'est un retour de tunnel
    if (/(paypal|stripe|klarna|adyen|checkout)\./i.test(h)) return null;
    return { source: h, medium: 'referral' };
  }

  /* CAPTURE EN MÉMOIRE — ne lit que l'URL et le référent de la page : rien n'est lu ni écrit sur l'appareil.
     Renvoie null pour une auto-référence (navigation interne : ne rien écraser). */
  function capterPage() {
    var p = params();
    var o = {
      t: new Date().toISOString(),
      lp: (location.pathname + location.search).slice(0, 190),
      ref: (document.referrer || '').slice(0, 190)
    };

    // 1. un identifiant de clic publicitaire prime sur tout le reste
    for (var k in CLICS) {
      var v = p.get(k);
      if (v) {
        var sm = CLICS[k].split('/');
        /* ⚠ 200 caractères : un gclid en fait ~97. Coupé à 60 (06/08), il était inutilisable. */
        o.source = sm[0]; o.medium = sm[1]; o.clic = k + ':' + String(v).slice(0, 200);
        break;
      }
    }
    // 1 bis. les marqueurs Google Ads qui accompagnent le clic (parfois SEULS, sur iPhone)
    var gs = p.get('gad_source'), gc = p.get('gad_campaignid');
    if (gs || gc) {
      o.gad = 'source=' + String(gs || '').slice(0, 12) + ';campagne=' + String(gc || '').slice(0, 30);
      if (!o.source) { o.source = 'google'; o.medium = 'cpc'; }
    }
    // 2. sinon les UTM, qui sont une déclaration explicite
    if (!o.source) {
      var us = p.get('utm_source');
      if (us) {
        o.source = String(us).slice(0, 60);
        o.medium = String(p.get('utm_medium') || '(not set)').slice(0, 40);
      }
    }
    // 3. sinon le référent
    if (!o.source) {
      var r = depuisReferent(document.referrer);
      if (!r) return null;              // auto-référence : ne rien écraser
      o.source = r.source; o.medium = r.medium;
    }
    var c = p.get('utm_campaign'); if (c) o.campagne = String(c).slice(0, 60);
    var tm = p.get('utm_term');    if (tm) o.terme = String(tm).slice(0, 80);
    return o;
  }
  var page = null;
  try { page = capterPage(); } catch(e){window.LE&&LE(e)}

  // ── enregistrement : SEULEMENT une fois l'accord acquis ───────────────────
  var prem = null, dern = null, actif = false, enregistre = false;

  function enregistrer() {
    if (enregistre) return;
    enregistre = true;
    prem = lire(CLE);
    var derniereConnue = lire(CLE_D) || prem;
    var neuf = page;
    /* ⚠ Une navigation INTERNE arrive souvent sans référent du tout (redirection de langue, permalien panier).
       La compter comme un nouveau « direct » recouvrirait la vraie provenance. Tant qu'une visite est en cours
       (30 min), un référent vide = continuation, pas nouvelle source. */
    if (neuf && neuf.source === '(direct)' && derniereConnue &&
        (Date.now() - new Date(derniereConnue.t).getTime()) < 30 * 60000) neuf = null;
    /* L'accord arrive AILLEURS que sur la page d'arrivée (le visiteur a d'abord navigué, ou crid-geo l'a redirigé
       avant qu'il ait pu répondre) : le référent est alors notre propre site et la vraie source est perdue — c'est
       le prix de « rien avant l'accord ». On note une trace HONNÊTE plutôt que rien : la commande garde sa page et
       ses identifiants de session, et on la distingue d'un visiteur qui a refusé. Un clic payant ultérieur la remplace. */
    if (!neuf && !prem) {
      neuf = { t: new Date().toISOString(), lp: (location.pathname + location.search).slice(0, 190),
               ref: (document.referrer || '').slice(0, 190), source: '(inconnue)', medium: '(accord apres l arrivee)' };
    }
    if (neuf) {
      /* Le DERNIER clic publicitaire survit aux visites suivantes sans clic (annonce → départ → retour en direct pour
         acheter : le parcours le plus courant). On le reporte avec SA date ; attributs() l'ignore au-delà de 90 jours. */
      var anc = derniereConnue || {};
      if (!neuf.clic && (anc.clic || anc.dclic)) { neuf.dclic = anc.clic || anc.dclic; neuf.dclic_t = anc.clic ? anc.t : anc.dclic_t; }
      if (!neuf.gad && (anc.gad || anc.dgad)) { neuf.dgad = anc.gad || anc.dgad; neuf.dgad_t = anc.gad ? anc.t : anc.dgad_t; }
      // première visite : on ne l'écrase QUE si elle a expiré, ou si la nouvelle source est payante
      // (un clic payant qui arrive après une visite directe doit être crédité)
      var perime = !prem || (Date.now() - new Date(prem.t).getTime()) > JOURS * 86400000;
      var premPayant = prem && (prem.clic || prem.gad);
      if (perime || (!premPayant && (neuf.clic || neuf.gad))) { ecrire(CLE, neuf); prem = neuf; }
      ecrire(CLE_D, neuf);
    }
    dern = lire(CLE_D) || prem;
  }

  // ── ce qui partira dans la commande ───────────────────────────────────────
  function recent(t) { try { return !!t && (Date.now() - new Date(t).getTime()) < 90 * 86400000; } catch (e) { return false; } }

  function attributs() {
    var a = {
      'lys_source': prem.source + ' / ' + prem.medium,
      'lys_landing': prem.lp,
      'lys_first_seen': prem.t
    };
    if (prem.ref) a['lys_referrer'] = prem.ref;
    if (prem.campagne) a['lys_campagne'] = prem.campagne;
    if (prem.terme) a['lys_terme'] = prem.terme;
    if (prem.clic) a['lys_clic'] = prem.clic;
    if (prem.gad) a['lys_gad'] = prem.gad;
    if (dern && (dern.source !== prem.source || dern.medium !== prem.medium))
      a['lys_source_derniere'] = dern.source + ' / ' + dern.medium;
    /* 19/09 — le DERNIER clic publicitaire, quand il diffère du premier : c'est lui que Google Ads créditera.
       Il peut venir de la dernière visite elle-même (dern.clic) ou avoir été reporté d'une visite d'avant (dern.dclic). */
    if (dern) {
      var dClic = dern.clic || (recent(dern.dclic_t) ? dern.dclic : null);
      if (dClic && dClic !== prem.clic) {
        a['lys_clic_dernier'] = dClic;
        a['lys_clic_dernier_le'] = String(dern.clic ? dern.t : dern.dclic_t).slice(0, 10);
      }
      var dGad = dern.gad || (recent(dern.dgad_t) ? dern.dgad : null);
      if (dGad && dGad !== prem.gad) a['lys_gad_dernier'] = dGad;
    }
    try { var er = window.LYS_ERR && window.LYS_ERR(); if (er) a['lys_js_err'] = er; } catch(e){window.LE&&LE(e)}
    /* Les identifiants Google Analytics sont des données ANALYTIQUES : ils ne partent que si l'analytique est accordée aussi. */
    try {
      var c = api();
      if (c && typeof c.analyticsProcessingAllowed === 'function' && c.analyticsProcessingAllowed() === true) {
        var mc = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.(\d+\.\d+)/);
        if (mc) a['lys_ga_cid'] = mc[1];
        var ms = document.cookie.match(/(?:^|;\s*)_ga_[A-Z0-9]+=GS\d\.\d\.s?(\d{9,11})/);
        if (ms) a['lys_ga_sid'] = ms[1];
      }
    } catch(e){window.LE&&LE(e)}
    return a;
  }

  /* ⚠ On garde une référence au fetch d'ORIGINE : plus bas on enveloppe window.fetch pour détecter
     les ajouts au panier. Sans cette référence, nos propres appels /cart/update.js se
     redéclencheraient eux-mêmes en boucle. */
  var fetchOrig = window.fetch ? window.fetch.bind(window) : null;

  /* On n'écrit dans le panier QUE s'il contient déjà quelque chose, QUE si l'accord est acquis,
     et on ne refait pas l'écriture si elle est déjà bonne. */
  var enCours = false;
  function poser() {
    if (!actif || !prem || enCours || !fetchOrig) return;
    enCours = true;
    fetchOrig('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.item_count || !actif || !prem) { enCours = false; return; }   // l'accord a pu être retiré entre-temps
        var a = attributs();
        var actuel = c.attributes || {};
        var identique = true;
        for (var k in a) { if (actuel[k] !== a[k]) { identique = false; break; } }
        if (identique) { enCours = false; return; }
        return fetchOrig('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: a })
        }).then(function () { enCours = false; });
      })
      .catch(function () { enCours = false; });
  }

  /* RETRAIT DE L'ACCORD : /cart/update.js FUSIONNE les attributs, il ne supprime jamais une clé absente. Ce qui avait été
     gravé pendant que l'accord tenait partirait donc quand même dans la commande. On vide nos clés, une fois, au moment
     du retrait — jamais aux chargements suivants (pas d'appel au panier pour un visiteur qui a refusé). */
  function viderPanier() {
    if (!fetchOrig) return;
    fetchOrig('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var at = (c && c.attributes) || {}, vide = {}, n = 0;
        for (var k in at) { if (/^lys_/.test(k) && at[k] !== '') { vide[k] = ''; n++; } }
        if (!n) return;
        return fetchOrig('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: vide })
        });
      })
      .catch(function () {});
  }

  if (fetchOrig && window.fetch && !window.fetch.__lysAttr) {
    var enveloppe = function (entree) {
      var u = '';
      try { u = (typeof entree === 'string') ? entree : (entree && entree.url) || ''; } catch(e){window.LE&&LE(e)}
      var p = fetchOrig.apply(null, arguments);
      if (/\/cart\/(add|change|clear)(\.js)?(\?|$)/.test(u)) {
        // effet de bord seulement : on renvoie la promesse d'origine, intacte
        try { p.then(function (r) { if (r && r.ok) setTimeout(poser, 80); }, function () {}); } catch(e){window.LE&&LE(e)}
      }
      return p;
    };
    enveloppe.__lysAttr = 1;
    try { window.fetch = enveloppe; } catch(e){window.LE&&LE(e)}
  }

  // au chargement, sans gêner la peinture
  function planifier() {
    if (window.requestIdleCallback) requestIdleCallback(poser, { timeout: 4000 });
    else setTimeout(poser, 1800);
  }

  // et juste avant de partir au paiement — c'est le dernier moment utile
  document.addEventListener('click', function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest(
        'a[href*="/checkout"],button[name="checkout"],[data-checkout],form[action*="/checkout"] button');
      if (el) poser();
    } catch(err){window.LE&&LE(err)}
  }, true);

  // le panier a changé (ajout produit) → on repose l'attribution
  document.addEventListener('cart:updated', poser);
  document.addEventListener('cart:refresh', poser);

  // ── le consentement commande tout ─────────────────────────────────────────
  function api() { return window.Shopify && window.Shopify.customerPrivacy; }

  /* 'oui' = accord (ou pays sans accord exigé) · 'non' = refus explicite · 'attente' = pas encore de réponse */
  function etat() {
    try {
      var c = api();
      if (!c || typeof c.marketingAllowed !== 'function') return 'attente';
      if (c.marketingAllowed() === true) return 'oui';
      var v = typeof c.currentVisitorConsent === 'function' ? c.currentVisitorConsent() : null;
      if (v && v.marketing === 'no') return 'non';
      return 'attente';
    } catch (e) { return 'attente'; }
  }

  // repère de contrôle, lisible depuis la console ou un test automatisé
  function publier(e) {
    try {
      window.LYS_ATTR = { etat: e, page: page, premiere: prem, derniere: dern, attributs: (actif && prem) ? attributs() : null };
    } catch(err){window.LE&&LE(err)}
  }

  function evaluer() {
    var e = etat();
    if (e === 'oui') {
      if (!actif) {
        try { enregistrer(); } catch(err){window.LE&&LE(err)}
        actif = true;
        if (prem) planifier();
      }
    } else if (e === 'non') {
      var retrait = actif;                   // l'accord tenait sur CETTE page et vient d'être retiré
      actif = false; enregistre = false; prem = null; dern = null;
      effacer(CLE); effacer(CLE_D);          // refus ou retrait de l'accord : on ne garde rien
      if (retrait) viderPanier();
    }
    publier(e);
  }

  document.addEventListener('visitorConsentCollected', evaluer);
  try {
    if (api()) evaluer();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) evaluer(); });
      publier('attente');
    } else publier('attente');
  } catch(e){window.LE&&LE(e)}
})();
